import { render } from "./LocationUnit.vue?vue&type=template&id=03f906b4&scoped=true"
import script from "./LocationUnit.vue?vue&type=script&lang=js"
export * from "./LocationUnit.vue?vue&type=script&lang=js"

import "./LocationUnit.vue?vue&type=style&index=0&id=03f906b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f906b4"]])

export default __exports__